<template>
  <div class="comment btn-float top left"
       :class="{expanded: expanded}"
       @click="(evt) => $emit('click', evt)"
       :style="style">

    <i class="mdi mdi-comment-text"></i>

    <transition name="fade">
      <div class="text text-sm"
           v-if="expanded">{{$t('message.campaigns.message.addComment')}}</div>
    </transition>

  </div>
</template>

<script>
export default {
  data() {
    return {
      expanded: false,
    };
  },

  props: {
    positioning: {
      type: Number,
      required: false
    }
  },

  computed: {
    style() {
      return {
        "left": this.isValidPositioning ? `${this.positioning}px` : ""
      }
    },
    isValidPositioning() {
      return this.positioning > 0
    },
  },

  mounted() {
    setTimeout(() => (this.expanded = true), 2000);
    setTimeout(() => (this.expanded = false), 7000);
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.comment {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: border-radius 0.4s 0.2s, width 0.4s;

  &.expanded {
    border-radius: 14px;
    width: 200px;
    transition: border-radius 0.2s, width 0.4s;
  }

  .text {
    display: flex;
    align-items: center;
    white-space: nowrap;
    text-align: left;

    &.fade-enter-active,
    &.fade-leave-active {
      opacity: 1;
      transition: all 0.3s;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
